import { request } from '@kibt/krn-utils';
import { api } from '@/common/api';

/**
 * 领取自建优惠劵
 */
export function postClaimCoupon(params: { batchId: number | string }) {
    return request.post(api(`/rest/o/ecommerce/marketing/c/customer/coupon/claim?batchId=${params.batchId}`)).then((res) => {
        if (res.result === 1) {
            return res;
        } else {
            return Promise.reject(res);
        }
    });
}
